module.exports = __webpack_public_path__ + "img/banner_login.7f2b5399.png";